import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import "../../../assets/loginAssets/loginStyles.css";
import "./ForgotPassword.css";
import { createNotification } from '../../../shared/components/Popup';
import { basicApi } from '../../../shared/services/apiService';
import { messages } from '../../../shared/constants/messages';

function ForgotPassword() {
  const navigate = useNavigate();
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);

  const [username, setUsername] = useState("");
  //   const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [token, setToken] = useState("");

  const [errors, setErrors] = useState({});
  const [showVerificationSection, setShowVerificationSection] = useState(false);
  const [recoveryEmail, setRecoveryEmail] = useState("");
  const [touched, setTouched] = useState({
    username: false,
    // oldPassword: false,
    newPassword: false,
    confirmPassword: false,
    token: false,
  });

  const getRequestErrors = (currentUsername) => {
    const newErrors = {};
    if (!currentUsername || currentUsername.trim() === "") {
      newErrors.username = "username is required!";
    }
    return newErrors;
  };

  const getConfirmErrors = ({
    username: currentUsername,
    // oldPassword: currentOldPassword,
    newPassword: currentNewPassword,
    confirmPassword: currentConfirmPassword,
    token: currentToken,
  }) => {
    const newErrors = {};
    if (!currentUsername || currentUsername.trim() === "") {
      newErrors.username = "username is required!";
    }

    if (!currentNewPassword || currentNewPassword.trim() === "") {
      newErrors.newPassword = "new password is required!";
    } else {
      if (currentNewPassword.length < 8) {
        newErrors.newPassword = "password must be at least 8 characters long.";
      } else if (!/[a-z]/.test(currentNewPassword)) {
        newErrors.newPassword =
          "password must include at least one lowercase letter.";
      } else if (!/[A-Z]/.test(currentNewPassword)) {
        newErrors.newPassword =
          "password must include at least one uppercase letter.";
      } else if (!/[0-9]/.test(currentNewPassword)) {
        newErrors.newPassword = "password must include at least one number.";
      } else if (!/[^A-Za-z0-9]/.test(currentNewPassword)) {
        newErrors.newPassword =
          "password must include at least one special character.";
      } else if (/\s/.test(currentNewPassword)) {
        newErrors.newPassword = "password must not contain spaces.";
      }
    }
    if (!currentConfirmPassword || currentConfirmPassword.trim() === "") {
      newErrors.confirmPassword = "confirm password is required!";
    } else if (currentNewPassword !== currentConfirmPassword) {
      newErrors.confirmPassword = "confirm password does not match.";
    }
    // if (currentNewPassword && currentNewPassword.trim() !== "") {
    //   newErrors.newPassword =
    //     "new password must be different from old password.";
    // }
    if (!currentToken || currentToken.trim() === "") {
      newErrors.token = "verification code is required!";
    }
    return newErrors;
  };

  const getVisibleErrors = (allErrors, touchedFields) => {
    const visibleErrors = {};
    Object.keys(allErrors).forEach((key) => {
      if (touchedFields[key]) {
        visibleErrors[key] = allErrors[key];
      }
    });
    return visibleErrors;
  };

  const validateOnTyping = (nextValues, nextTouched) => {
    const requestErrors = getRequestErrors(nextValues.username);
    const confirmErrors = showVerificationSection
      ? getConfirmErrors(nextValues)
      : {};
    const mergedErrors = { ...requestErrors, ...confirmErrors };
    setErrors(getVisibleErrors(mergedErrors, nextTouched));
  };

  const validateRequest = () => {
    return getRequestErrors(username);
  };

  const validateConfirm = () => {
    return getConfirmErrors({
      username,
      newPassword,
      confirmPassword,
      token,
    });
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    const nextValues = {
      username: value,
      newPassword: "",
      confirmPassword: "",
      token: "",
    };
    const nextTouched = {
      ...touched,
      username: true,
      newPassword: false,
      confirmPassword: false,
      token: false,
    };

    setUsername(value);
    setNewPassword("");
    setConfirmPassword("");
    setToken("");
    setRecoveryEmail("");
    setShowVerificationSection(false);
    setTouched(nextTouched);
    validateOnTyping(nextValues, nextTouched);
  };

  //   const handleOldPasswordChange = (e) => {
  //     const value = e.target.value;
  //     const nextValues = {
  //       username,
  //       newPassword,
  //       confirmPassword,
  //       token,
  //     };
  //     const nextTouched = { ...touched, oldPassword: true };
  //     setOldPassword(value);
  //     setTouched(nextTouched);
  //     validateOnTyping(nextValues, nextTouched);
  //   };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    const nextValues = {
      username,
      newPassword: value,
      confirmPassword,
      token,
    };
    const nextTouched = { ...touched, newPassword: true };
    setNewPassword(value);
    setTouched(nextTouched);
    validateOnTyping(nextValues, nextTouched);
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    const nextValues = {
      username,
      //   oldPassword,
      newPassword,
      confirmPassword: value,
      token,
    };
    const nextTouched = { ...touched, confirmPassword: true };
    setConfirmPassword(value);
    setTouched(nextTouched);
    validateOnTyping(nextValues, nextTouched);
  };

  const handleTokenChange = (e) => {
    const value = e.target.value;
    const nextValues = {
      username,
      //   oldPassword,
      newPassword,
      confirmPassword,
      token: value,
    };
    const nextTouched = { ...touched, token: true };
    setToken(value);
    setTouched(nextTouched);
    validateOnTyping(nextValues, nextTouched);
  };

  const handleRequestCode = (e) => {
    e.preventDefault();
    const nextTouched = { ...touched, username: true };
    setTouched(nextTouched);
    const newErrors = validateRequest();
    if (Object.keys(newErrors).length > 0) {
      setErrors(getVisibleErrors(newErrors, nextTouched));
      return;
    }

    setErrors({});
    setLoadingRequest(true);

    const payload = {
      Username: username,
    };

    basicApi(payload, "api/auth/forgot-password/request")
      .then((result) => {
        if (result?.code === 1) {
          setShowVerificationSection(true);
          setRecoveryEmail(result?.data?.Email || "");
          createNotification({
            type: "success",
            message: result?.message || "Verification code sent to your email.",
          })();
          return;
        }

        setShowVerificationSection(false);
        setRecoveryEmail("");
        setNewPassword("");
        setConfirmPassword("");
        setToken("");
        setTouched((prev) => ({
          ...prev,
          newPassword: false,
          confirmPassword: false,
          token: false,
        }));

        createNotification({
          type: "error",
          message: result?.message || "Unable to send verification code.",
        })();
      })
      .catch(() => {
        createNotification({
          type: "error",
          message: messages.technicalError,
        })();
      })
      .finally(() => setLoadingRequest(false));
  };

  const handleConfirmPassword = (e) => {
    e.preventDefault();
    if (!showVerificationSection) {
      return;
    }

    const nextTouched = {
      ...touched,
      username: true,
      //   oldPassword: true,
      newPassword: true,
      confirmPassword: true,
      token: true,
    };
    setTouched(nextTouched);
    const newErrors = validateConfirm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(getVisibleErrors(newErrors, nextTouched));
      return;
    }

    setErrors({});
    setLoadingConfirm(true);

    const payload = {
      NewPassword: newPassword,
      ResetCode: token,
      Username: username,
    };

    basicApi(payload, "api/auth/forgot-password/confirm")
      .then((result) => {
        if (result?.code === 1) {
          createNotification({
            type: "success",
            message: result?.message || "Password reset successful.",
          })();
          navigate("/");
          return;
        }

        createNotification({
          type: "error",
          message: result?.message || "Unable to reset password.",
        })();
      })
      .catch(() => {
        createNotification({
          type: "error",
          message: messages.technicalError,
        })();
      })
      .finally(() => setLoadingConfirm(false));
  };

  return (
    <div className="fp-page fontRegular custom-background">
      <div className="fp-overlay"></div>
      <div className="fp-card" role="region" aria-label="Reset password form">
        <div className="fp-card-header">
          <h1>Reset Password</h1>
          <p>
            {showVerificationSection
              ? "Set a secure password using the verification code."
              : "Enter your Email to receive a verification code."}
          </p>
        </div>

        <Form className="fp-form">
          {!showVerificationSection && (
            <>
              <Form.Group className="fp-form-group">
                <Form.Label className="fp-label">Email</Form.Label>
                <Form.Control
                  className="fp-input"
                  type="text"
                  value={username}
                  name="Username"
                  placeholder="example.email@immigration.go.tz"
                  isInvalid={!!errors.username}
                  onChange={handleUsernameChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.username}
                </Form.Control.Feedback>
              </Form.Group>

              <button
                type="button"
                className="fp-button"
                onClick={handleRequestCode}
                disabled={loadingRequest}
              >
                {loadingRequest ? "Sending..." : "Send Verification Code"}
              </button>
            </>
          )}

          {showVerificationSection && (
            <>
              {recoveryEmail && (
                <p className="fp-info">
                  A verification code has been sent to {recoveryEmail}
                </p>
              )}

              <Form.Group className="fp-form-group">
                <Form.Label className="fp-label">New Password</Form.Label>
                <Form.Control
                  className="fp-input"
                  type="password"
                  value={newPassword}
                  name="NewPassword"
                  placeholder="Enter new password"
                  isInvalid={!!errors.newPassword}
                  onChange={handleNewPasswordChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.newPassword}
                </Form.Control.Feedback>
              </Form.Group>

              <p className="fp-help-text">
                Use at least 8 characters, including uppercase, lowercase,
                number, and a special character.
              </p>

              <Form.Group className="fp-form-group">
                <Form.Label className="fp-label">Confirm Password</Form.Label>
                <Form.Control
                  className="fp-input"
                  type="password"
                  value={confirmPassword}
                  name="ConfirmPassword"
                  placeholder="Re-enter new password"
                  isInvalid={!!errors.confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.confirmPassword}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="fp-form-group">
                <Form.Label className="fp-label">Verification Code</Form.Label>
                <Form.Control
                  className="fp-input"
                  type="text"
                  value={token}
                  name="Token"
                  placeholder="Enter verification code"
                  isInvalid={!!errors.token}
                  onChange={handleTokenChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.token}
                </Form.Control.Feedback>
              </Form.Group>

              <button
                type="button"
                className="fp-button"
                onClick={handleConfirmPassword}
                disabled={
                  loadingConfirm ||
                  !!errors.newPassword ||
                  !!errors.confirmPassword ||
                  !!errors.token
                }
              >
                {loadingConfirm ? "Please wait..." : "Reset Password"}
              </button>
            </>
          )}

          <p className="fp-back-link">
            <Link to="/">Back to Login</Link>
          </p>
        </Form>
      </div>
    </div>
  );
}

export default ForgotPassword;
